import { SvgIcon, SvgIconProps } from '@mui/material';

export function OwnedAssetsIcon(props: SvgIconProps) {
  const { color } = props;

  return (
    <SvgIcon {...props}>
      <g clip-path="url(#clip0_266_15097)">
        <path
          d="M0 20H3.80771V9.52381H0V20ZM20 2.85714V0.952381H17.6202V0H15.7163V0.952381H14.2884C13.7649 0.952381 13.3365 1.38095 13.3365 1.90476V5.71429C13.3365 6.2381 13.7649 6.66667 14.2884 6.66667H18.0961V8.57143H13.3365V10.4762H15.7163V11.4286H17.6202V10.4762H19.0481C19.5716 10.4762 20 10.0476 20 9.52381V5.71429C20 5.19048 19.5716 4.7619 19.0481 4.7619H15.2404V2.85714H20ZM18.0866 15.2381H11.4231L9.4336 14.5429L9.74774 13.6476L11.4231 14.2857H14.1076C14.7263 14.2857 15.2308 13.781 15.2308 13.1619C15.2308 12.6952 14.9357 12.2762 14.4979 12.1048L7.58686 9.52381H5.71157V18.1143L12.3751 20L20 17.1429C19.9905 16.0952 19.1433 15.2381 18.0866 15.2381Z"
          fill={color || '#0A0B0D'}
        />
      </g>
      <defs>
        <clipPath id="clip0_266_15097">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}
